$(() => {
  $('.slider-unquestionable').slick({
    dots: true,
    infinite: true,
    autoplay: false,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }]
  });

  let current_video = $('.slider-unquestionable .slick-active').find('iframe');
  let current_slide = $('.slick-current');

  if (_.get(current_video[0], 'src')) {
    current_video[0].src += '&autoplay=1';
  }

  $('.slider-unquestionable').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $(this).find('.slick-slide').each(function() {
      current_slide = $('.slick-current');
      current_video.attr('src', current_video.attr('src').replace('&autoplay=1', ''));
      current_slide.html(current_slide.html());
    });
  });

  $('.slider-unquestionable').on('afterChange', function(event, slick, currentSlide, nextSlide) {
    current_video = $(this).find('.slick-active iframe');
    current_video[0].src += '&autoplay=1';
  });

});
